import { useState } from "react";
import {
    Box,
    Container,
} from "@mui/material";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styles } from '../components/changePassword/styles';
import { ChangePasswordComponent } from "../components/changePassword/changePasswordComponent";

export default function ChangePassword() {
    const [value, setValue] = useState('1');
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Container component="main">
            <Box sx={styles.containerMain}>
                <TabContext value={value}>
                    <Box>
                        <TabList
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                            sx={{
                                '& .MuiTab-root': { // Inactive tab styling
                                    textTransform: 'none',
                                    textAlign: "center",
                                    fontSize: "16px",
                                    color: "black",
                                    fontWeight: "500",
                                    borderBottom: "4px solid #F0F1F5",  // Grey border for inactive tab
                                },
                                '& .Mui-selected': { // Active tab styling
                                    color: "black",
                                    fontWeight: "500",
                                    textAlign: "center",
                                    borderBottom: "4px solid #C22249",  // Red border for active tab
                                },
                                '& .MuiTabs-indicator': {
                                    backgroundColor: "transparent",
                                    textAlign: "center", // Hides the default indicator
                                }
                            }}
                        >
                            <Tab
                                label="Staff"
                                value="1"
                                sx={styles.firstTabSubModel}
                            />
                            <Tab
                                label="Admin"
                                value="2"
                                sx={styles.firstTabSubModel}
                            />
                        </TabList>
                    </Box>
                    <TabPanel value="1">
                        <ChangePasswordComponent loginType={1} />
                    </TabPanel>
                    <TabPanel value="2">
                        <ChangePasswordComponent loginType={0} />
                    </TabPanel>
                </TabContext>
            </Box>
        </Container>
    );
}
